module.exports = __webpack_public_path__ + "static/rainbowgown-7a67c23a83119d7aab5a1fbe2218a936.png";